export function is360Law(): boolean {
  return window.sessionStorage.getItem("whiteLabel") === "360Law";
}
